import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { getLogistics, updateLogistics, getTransport } from '@/services/productDetail';
import FooterToolBar from '@/components/tool/FooterToolBar';
export default {
  name: 'logisticsInformation',
  i18n: require('../i18n-productDetail'),
  components: {
    FooterToolBar: FooterToolBar
  },
  props: {
    productId: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      queryLoading: false,
      logisticsInformationForm: {
        id: 0,
        //商品id
        daysOfStock: "",
        //备货天数
        distribution: '0',
        //要求配送（0:需要配送 1：不需要配送）
        transportFirstId: undefined,
        //运输方式首选id
        transportSecondIdList: [] //运输方式次选id集合
      },
      transportList: [],
      rules: {
        daysOfStock: [{
          required: true,
          message: this.$t("public.enterPlease"),
          trigger: 'blur'
        }],
        transportFirstId: [{
          required: true,
          message: this.$t("publicuse.pleaseselect"),
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    //初始化
    this.getInitialValue();
  },
  methods: {
    //初始化
    getInitialValue: function getInitialValue() {
      var self = this;
      //获取运输方式列表
      getTransport().then(function (response) {
        if (response.data.code == 200) {
          self.transportList = response.data.data;
        } else {
          self.$notification.error({
            message: res.data.message
          });
        }
      });
      //获取配送详情
      //				console.log(self.productId)
      if (self.productId > 0) {
        getLogistics(self.productId).then(function (res) {
          if (res.data.code == 200) {
            var rs = res.data.data;
            self.logisticsInformationForm.id = rs.id;
            if (rs.daysOfStock > 0) {
              self.logisticsInformationForm.daysOfStock = rs.daysOfStock;
            }
            if (rs.distribution == 0 || rs.distribution == 1) {
              self.logisticsInformationForm.distribution = rs.distribution.toString();
            }
            if (rs.transportFirstId > 0) {
              self.logisticsInformationForm.transportFirstId = rs.transportFirstId;
            }
            if (rs.transportSecondIdList != null && rs.transportSecondIdList.length > 0) {
              self.logisticsInformationForm.transportSecondIdList = rs.transportSecondIdList;
            }
          }
        });
      }
    },
    //保存
    saveData: function saveData() {
      var self = this;

      //校验：首选运输方式
      //				if (self.logisticsInformationForm.distribution == 0 && self.logisticsInformationForm.transportFirstId == undefined) {
      //					self.$message.error(self.$t('productDetail.checkExpressWayPrimary'));
      //					return;
      //				}

      self.$refs.logisticsInformationForm.validate(function (valid) {
        if (valid) {
          //调接口
          self.queryLoading = true;
          var newData = self.logisticsInformationForm;
          updateLogistics(newData).then(function (result) {
            if (result.data.code == 200) {
              self.$message.success(self.$t('public.saveSuccessfully'));
            }
            self.queryLoading = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    changeDistribution: function changeDistribution() {
      var self = this;
      if (self.logisticsInformationForm.distribution == 1) {
        self.logisticsInformationForm.transportFirstId = undefined;
        self.logisticsInformationForm.transportSecondIdList = [];
      }
    }
  }
};